// Computes aria-label for OutlineButton by combining context (buttonLabel)
// with the button text (children). This creates accessible labels like
// "Worklife Service Learn More" or "Depression Learn More".
export const computeOutlineButtonAriaLabel = (children, buttonLabel) => {
  const childText = typeof children === 'string' ? children.trim() : null;
  const normalizedLabel =
    typeof buttonLabel === 'string' && buttonLabel.trim().length > 0
      ? buttonLabel.trim()
      : undefined;

  // If no buttonLabel provided, return undefined (screen reader uses visible text)
  if (!normalizedLabel) {
    return undefined;
  }

  // If buttonLabel already includes the button text, use it as-is
  if (
    childText &&
    normalizedLabel.toLowerCase().includes(childText.toLowerCase())
  ) {
    return normalizedLabel;
  }

  // Otherwise, combine buttonLabel (context) with button text
  return childText ? `${normalizedLabel} ${childText}` : normalizedLabel;
};
